var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPantone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 509.996 509.996",
    height: 512,
    viewBox: "0 0 509.996 509.996",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.833,
    x2: 287.726,
    y1: 374.801,
    y2: 499.417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0462,
    stopColor: "#ebf4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.491,
    x2: 256.491,
    xlinkHref: "#lg1",
    y1: 475.569,
    y2: 528.971
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(0 1 -1 0 142.998 695.268)",
    gradientUnits: "userSpaceOnUse",
    x1: -281.227,
    x2: -281.227,
    xlinkHref: "#lg1",
    y1: 77.001,
    y2: 146.371
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(0 1 -1 0 142.998 695.268)",
    gradientUnits: "userSpaceOnUse",
    x1: -302.505,
    x2: -247.063,
    y1: -268.46,
    y2: -213.018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(0 1 -1 0 142.998 695.268)",
    gradientUnits: "userSpaceOnUse",
    x1: -303.694,
    x2: -245.155,
    y1: -181.072,
    y2: -122.533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(0 1 -1 0 142.998 695.268)",
    gradientUnits: "userSpaceOnUse",
    x1: -302.505,
    x2: -247.063,
    y1: -91.307,
    y2: -35.865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b444f"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#174461",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.358,
    x2: 150.133,
    xlinkHref: "#lg2",
    y1: 466.349,
    y2: 365.189
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.402,
    x2: 264.347,
    xlinkHref: "#lg3",
    y1: 273.567,
    y2: 357.512
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.293,
    x2: 299.596,
    xlinkHref: "#lg1",
    y1: 347.539,
    y2: 387.842
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 .707 -.707 .707 215.494 318.018)",
    gradientUnits: "userSpaceOnUse",
    x1: -16.629,
    x2: -16.629,
    xlinkHref: "#lg1",
    y1: 182.383,
    y2: 251.753
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.707 .707 -.707 .707 215.494 318.018)",
    gradientUnits: "userSpaceOnUse",
    x1: -37.907,
    x2: 17.535,
    y1: -163.078,
    y2: -107.636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7acbff"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(.707 .707 -.707 .707 215.494 318.018)",
    gradientUnits: "userSpaceOnUse",
    x1: -39.096,
    x2: 19.444,
    y1: -75.69,
    y2: -17.151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.707 .707 -.707 .707 215.494 318.018)",
    gradientUnits: "userSpaceOnUse",
    x1: -37.907,
    x2: 17.535,
    y1: 14.075,
    y2: 69.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45a2e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.031,
    x2: 146.788,
    xlinkHref: "#lg2",
    y1: 323.055,
    y2: 346.127
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.664,
    x2: 194.363,
    xlinkHref: "#lg3",
    y1: 172.287,
    y2: 331.986
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.955,
    x2: 95.955,
    xlinkHref: "#lg1",
    y1: 443.999,
    y2: 513.369
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.676,
    x2: 130.119,
    y1: 98.538,
    y2: 153.98
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.488,
    x2: 132.027,
    y1: 185.926,
    y2: 244.465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.676,
    x2: 130.119,
    y1: 275.691,
    y2: 331.133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.458,
    x2: 86.435,
    y1: 497.958,
    y2: 448.935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffebb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.95,
    x2: 110.345,
    xlinkHref: "#lg4",
    y1: 446.45,
    y2: 472.844
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(-1 0 0 -1 -552.271 838.266)",
    gradientUnits: "userSpaceOnUse",
    x1: -656.632,
    x2: -641.853,
    xlinkHref: "#lg4",
    y1: 371.405,
    y2: 386.185
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 414.041c0-52.994 42.96-95.955 95.954-95.955h391.22c12.604 0 22.821 10.217 22.821 22.821v146.266c0 12.604-10.217 22.821-22.821 22.821h-391.22c-52.994.002-95.954-42.959-95.954-95.953z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.987 437.828v.046c10.598 41.464 48.201 72.121 92.968 72.121h391.22c12.604 0 22.821-10.217 22.821-22.821v-49.346z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.954 318.087c-52.994 0-95.954 42.96-95.954 95.954 0 52.994 42.96 95.954 95.954 95.954z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.957 482.58v-137.078h73.772c11.563 0 20.936 9.373 20.936 20.936v95.206c0 11.563-9.373 20.936-20.936 20.936z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.249 482.58v-137.078h94.708v137.078z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.541 461.644v-95.206c0-11.563 9.373-20.936 20.936-20.936h73.772v137.078h-73.772c-11.563 0-20.936-9.373-20.936-20.936z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m113.003 411.838v-58.565c0-4.292 3.479-7.771 7.771-7.771h15.541c4.292 0 7.771 3.479 7.771 7.771v58.565c0 4.292-3.479 7.771-7.771 7.771h-15.541c-4.292-.001-7.771-3.48-7.771-7.771z",
    fill: "#7acbff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m507.35 497.833c-3.826 7.24-11.427 12.163-20.175 12.163h-391.221c-52.999 0-86.668-37.4-86.668-90.387 0-52.999 33.669-101.522 86.668-101.522h231.649z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.105 481.891c-37.473-37.473-37.473-98.228 0-135.7l276.634-276.634c8.912-8.912 23.362-8.912 32.274 0l103.426 103.426c8.912 8.912 8.912 23.362 0 32.274l-276.634 276.634c-37.473 37.473-98.228 37.473-135.7 0z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.439 172.983-26.349-26.349-355.703 355.701c34.951 14.856 76.915 8.058 105.417-20.444l276.634-276.634c8.913-8.912 8.913-23.362.001-32.274z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.104 346.191c-37.473 37.473-37.472 98.228 0 135.7 37.473 37.473 98.228 37.473 135.7 0z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m323.319 283.605-96.929-96.929 52.165-52.165c8.176-8.176 21.432-8.176 29.608 0l67.321 67.321c8.176 8.176 8.176 21.432 0 29.608z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.35 350.574-96.929-96.928 66.969-66.969 96.929 96.928z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.577 402.739-67.321-67.321c-8.176-8.176-8.176-21.432 0-29.608l52.165-52.165 96.929 96.929-52.165 52.165c-8.176 8.176-21.432 8.176-29.608 0z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m106.451 400.428-41.411-41.411c-3.035-3.035-3.035-7.955 0-10.989l10.989-10.989c3.035-3.035 7.955-3.035 10.989 0l41.412 41.412c3.035 3.035 3.035 7.955 0 10.989l-10.989 10.989c-3.035 3.034-7.955 3.034-10.99-.001z",
    fill: "#7acbff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m327.609 318.087-135.7-135.7-163.805 163.804c-37.472 37.473-34.135 94.106 3.337 131.579 37.473 37.473 94.89 41.594 132.363 4.122z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m95.955 509.996c-52.995 0-95.955-42.961-95.955-95.955v-391.22c0-12.604 10.217-22.821 22.821-22.821h146.266c12.604 0 22.821 10.217 22.821 22.821v391.22c.001 52.994-42.959 95.955-95.953 95.955z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 414.041c0 52.994 42.96 95.954 95.954 95.954 52.994 0 95.954-42.96 95.954-95.954z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m164.493 161.038h-137.077v-73.772c0-11.563 9.373-20.936 20.936-20.936h95.206c11.563 0 20.936 9.373 20.936 20.936v73.772z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.416 161.038h137.078v94.708h-137.078z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.557 350.455h-95.205c-11.563 0-20.936-9.373-20.936-20.936v-73.772h137.078v73.772c-.001 11.562-9.374 20.936-20.937 20.936z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m93.751 396.993h-58.565c-4.292 0-7.771-3.479-7.771-7.771v-15.541c0-4.292 3.479-7.771 7.771-7.771h58.565c4.292 0 7.771 3.479 7.771 7.771v15.541c0 4.292-3.479 7.771-7.771 7.771z",
    fill: "#7acbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.49 481.173-43.345-43.345-45.817 45.817 26.179 26.179c24.637-1.407 46.776-12.108 62.983-28.651z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 97.035,
    cy: 459.534,
    fill: "url(#SVGID_21_)",
    r: 32.566
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.035,
    cy: 459.534,
    fill: "url(#SVGID_22_)",
    r: 18.235
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPantone);
export default __webpack_public_path__ + "static/media/icon-pantone.8a8a2a6ed89efefa1b1487f79667f46c.svg";
export { ForwardRef as ReactComponent };